import { Icon } from "@iconify/react";

const keypad = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export function PinPad({
  value,
  onChange,
  maxLength,
  disabled = false,
  loading = false,
  message = `PIN de ${maxLength} dígitos`,
  error = false,
}) {
  function updatePin(nextValue) {
    onChange(nextValue.replace(/\D/g, "").slice(0, maxLength));
  }

  function appendDigit(digit) {
    if (disabled) return;
    updatePin(`${value}${digit}`);
  }

  return (
    <div className="w-full">
      <div className="relative">
        <input
          type="password"
          inputMode="numeric"
          autoComplete="off"
          pattern="[0-9]*"
          maxLength={maxLength}
          value={value}
          placeholder={"•".repeat(maxLength)}
          onChange={(event) => updatePin(event.target.value)}
          aria-label={`PIN de ${maxLength} dígitos`}
          aria-invalid={error}
          disabled={disabled}
          className={`h-14 w-full border-0 border-b-2 bg-transparent px-2 text-center text-2xl font-semibold tracking-[0.65em] text-neutral-900 outline-none transition-colors placeholder:text-neutral-300 placeholder:tracking-[0.35em] focus:ring-0 disabled:opacity-60 ${
            error
              ? "border-red-400"
              : "border-neutral-300 focus:border-blue-500"
          }`}
        />
        {loading && (
          <Icon
            icon="eos-icons:three-dots-loading"
            className="absolute right-0 top-1/2 -translate-y-1/2 animate-spin text-xl text-neutral-400"
          />
        )}
      </div>

      <div
        className={`mt-3 min-h-6 text-center text-sm font-medium ${
          error ? "text-red-600" : "text-neutral-400"
        }`}
        role="status"
        aria-live="polite"
      >
        {message}
      </div>

      <div className="mt-5 grid w-full grid-cols-3 gap-2">
        {keypad.map((digit) => (
          <button
            type="button"
            key={digit}
            onClick={() => appendDigit(digit)}
            disabled={disabled}
            className="flex h-14 touch-manipulation items-center justify-center rounded-full text-2xl font-medium text-neutral-700 transition-colors hover:bg-white/80 active:scale-95 active:bg-white disabled:opacity-40"
          >
            {digit}
          </button>
        ))}

        <button
          type="button"
          onClick={() => updatePin("")}
          disabled={disabled || !value.length}
          aria-label="Borrar PIN"
          className="flex h-14 touch-manipulation items-center justify-center rounded-full text-neutral-400 transition-colors hover:bg-white/80 active:scale-95 disabled:opacity-30"
        >
          <Icon icon="mdi:close" className="text-2xl" />
        </button>

        <button
          type="button"
          onClick={() => appendDigit("0")}
          disabled={disabled}
          className="flex h-14 touch-manipulation items-center justify-center rounded-full text-2xl font-medium text-neutral-700 transition-colors hover:bg-white/80 active:scale-95 active:bg-white disabled:opacity-40"
        >
          0
        </button>

        <button
          type="button"
          onClick={() => updatePin(value.slice(0, -1))}
          disabled={disabled || !value.length}
          aria-label="Eliminar último dígito"
          className="flex h-14 touch-manipulation items-center justify-center rounded-full text-neutral-400 transition-colors hover:bg-white/80 active:scale-95 disabled:opacity-30"
        >
          <Icon icon="mdi:backspace-outline" className="text-2xl" />
        </button>
      </div>
    </div>
  );
}
